module.exports = __webpack_public_path__ + "static/noun_945817-sphere.cef67c16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/noun_945817-sphere.svg
// module id = 455
// module chunks = 35783957827783